export const SET_QUESTIONS = 'SET_QUESTIONS'
